<template>
    <b-modal size="lg" id="location" centered   :title="$t('account-page-facility-my-page.map_setting')">
 
        <div class="row">
            <div class="col-lg-12 text-center" v-html="src">
            </div>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <button class="btn btn-outline-danger btn-block" @click="$bvModal.hide('location')">
                    {{$t("account-page-facility-my-page.close")}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "background.vue",
    data(){
        return {
            src: null
        }
    },
    methods: {
        async init(data){
            this.src = data;
            this.$bvModal.show("location");
        }
    }
}
</script>

<style scoped>

</style>